/**
 * Loader
 */
import React, { useEffect, useMemo, useRef } from 'react';
import {Animated, Dimensions, View} from 'react-native';
import { CUSTOM_LOADER, CUSTOM_LOADER_LOTTIE } from '../../assets';
import { isWeb } from '../../utils/Helper';
import { useCssStyle } from '../../customHook/getCssStyle';
import LottieView from 'lottie-react-native';

const {height, width} = Dimensions.get('window');

const Loader = ({size='medium', style}) => {

  const getStyles = useCssStyle();

  const spinValue = useRef(new Animated.Value(0)).current;

  useEffect(() => {
    Animated.loop(
      Animated.timing(spinValue, {
        toValue: 1,
        duration: 1500,
        useNativeDriver: isWeb() ? false : true, // Use native driver for better performance
      })
    ).start();
  }, [spinValue]);

   // interpolate beginning and end values (in this case 0 and 1)
   const spin = spinValue.interpolate({
    inputRange: [0, 1],
    outputRange: ['0deg', '540deg'],
  });


  const customStyle = useMemo(() => {
    return Array.isArray(style) ? Object.assign({}, ...style) : style || {};
  }, [style]);

  return (
    <View style={[getStyles(['loaderContainer'])]}>
        {CUSTOM_LOADER_LOTTIE ?
          <LottieView
            source={CUSTOM_LOADER_LOTTIE}
            style={getStyles(['customLoader_lottie'])}
            autoPlay
            loop
            id='customLoader_lottie'
          />
        : <Animated.Image
          source={CUSTOM_LOADER}
          style={getStyles(['customLoader', size == 'small' ? 'customLoader_small' : 'customLoader_medium', { transform: [{ rotate: spin }] }, customStyle])}
          resizeMode="contain"
        />}
    </View>
  );
};

export default Loader;
